import React, { useContext } from "react";
import upload_img from "../../assets/svg/upload_img.svg";
import upload_btn from "../../assets/svg/upload_btn.svg";
import item_img from "../../assets/svg/item_img.svg";
import add_item from "../../assets/svg/add_item.svg";
import backarrow from "../../assets/svg/backarrow.svg";
import { TimeContext } from "../../App.js";
import clk from "../../assets/svg/clk.svg";

const Vehicleadd = () => {
  const dateTime = useContext(TimeContext);
  return (
    <>
      <div className="container-fluid ">
        <div className="head">
          <div className="header">
            <div>
              <h5 className="mb-0">
                <img src={backarrow} alt="Back Arrow" /> Add Vehicle
              </h5>
            </div>
            <div className="header_btn">
              <button type="button" className="btn1">
                {" "}
                Cancel
              </button>
              <button type="button" className="btn2">
                {" "}
                Save{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="row gap-2 m-2">
          {" "}
          {/* 2px row gap */}
          <div className="col left ">
            <div className="row bg-white p-4  border border-1 rounded-4 ">
              <div>
                <h5>Verify Visitor mobile number</h5>
              </div>
              <div className="row mx-0 p-0 d-flex flex-wrap">
                <div className="col-md-6 col-sm-12 input_row_field ">
                  <div className="visiter_input_label">
                    <label> Mobile number</label>
                  </div>
                  <div className="mbl_text">
                    <input
                      type="text"
                      className="mbl_input"
                      placeholder="Mobile number"
                    />
                    <button type="button" className="otp_btn">
                      Send OTP
                    </button>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 input_row_field">
                  <div className="visiter_input_label">
                    <label> OTP verification</label>
                  </div>
                  <div className="otp-wrapper">
                    <input
                      type="text"
                      class="otp-input"
                      placeholder="Enter OTP"
                    />
                    <button class="otp-button">Verify</button>
                  </div>
                </div>

                <div className="row mx-0 p-0 d-flex flex-wrap">
                  <div className="col-md-6 col-sm-12 input_row_field">
                    <div className="visiter_input_label">
                      <label>Visiter name</label>
                    </div>
                    <div>
                      <input
                        type="text"
                        className="input_text"
                        placeholder="Enter here"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 input_row_field">
                    <div className="visiter_input_label">
                      <label>Location</label>
                    </div>
                    <div>
                      <input
                        type="text"
                        className="input_text"
                        placeholder="Enter here"
                      />
                    </div>
                  </div>
                </div>
                <div className="row mx-0 p-0 d-flex flex-wrap">
                  <div className="col-md-6 col-sm-12 input_row_field">
                    <div className="visiter_input_label">
                      <label> Vehicle type</label>
                    </div>
                    <div>
                      <select name="Vehicle_type" className="input_text" id="">
                        <option value="" selected disabled>
                          Select
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 input_row_field">
                    <div className="visiter_input_label">
                      <label>Vehicle number</label>
                    </div>
                    <div>
                      <input
                        type="text"
                        className="input_text"
                        placeholder="Enter here"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mx-0 p-0">
                <div className="input_row_field">
                  <div className="visiter_input_label">
                    <label>Email</label>
                  </div>
                  <div>
                    <input
                      type="number"
                      className="input_text"
                      placeholder="Enter here"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row  mt-4 bg-white p-4  border border-1 rounded-4 ">
              <div>
                <h5>Check list</h5>
              </div>
              <div className="check_field">
                <span>Drunken</span>
                <div className="chk-btns">
                  <button className="check-btn">✔ Yes</button>
                  <button className="check-btn">✖ No</button>
                </div>
              </div>
              <div className="check_field">
                <span>Temperature</span>
                <input
                  type="text"
                  className="temp-input"
                  placeholder="Temperature..."
                />
              </div>
            </div>
          </div>
          <div className="col right ">
            <div className="row border rounded-3 p-4 bg-white mt-2">
              <div className="d-flex justify-content-between ">
                <div>
                  {" "}
                  <h5>Visit details</h5>
                </div>
                <div
                  className="d-flex align-items-center bg-light px-3 py-1 rounded-pill shadow-sm text-muted fw-medium "
                  style={{ fontSize: "12px" }}
                >
                  <span>
                    {" "}
                    <img
                      src={clk}
                      alt="Clock Icon"
                      style={{ width: "22px", height: "14px" }}
                    />
                  </span>
                  <span>{dateTime}</span>
                </div>
              </div>
              <div className="row mx-0 p-0">
                <div className="col">
                  <div className="row input_row_field ">
                    <div className="input_label">
                      <label> Purpose of visit</label>
                    </div>
                    <div>
                      <select name="Vehicle_type" className="input_text" id="">
                        <option value="" selected disabled>
                          Select
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col ">
                  <div className="row input_row_field">
                    <div className="input_label">
                      <label> Department</label>
                    </div>
                    <div>
                      <select name="Vehicle_type" className="input_text" id="">
                        <option value="" selected disabled>
                          Select
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row border rounded-3 p-4 bg-white mt-2">
              <div className="row input_row_field mx-0 p-0">
                <div className="input_label">
                  <label>Driving licence number</label>
                </div>
                <div>
                  <input
                    type="text"
                    className="input_text"
                    placeholder="Enter here"
                  />
                </div>
              </div>
              <div>
                {" "}
                <h5>Proof details</h5>
              </div>
              <div className="proof_line">
                <hr />
              </div>
              <div className="row mx-0 p-0 ">
                <div className="row ">
                  <div>
                    <h6>Upload proof image</h6>
                  </div>
                </div>
                <div className="row gap-2 mx-0">
                  <div className="col img_con">
                    <div className="proof_img">
                      <img src={upload_img} alt="upload_img" />
                      <label htmlFor="">Upload driving licence image</label>
                      <button type="button" className="img_btn">
                        <img src={upload_btn} alt="upload_btn" />
                        <span>Upload</span>
                      </button>
                    </div>
                  </div>
                  <div className="col img_con">
                    <div className="proof_img">
                      <img src={upload_img} alt="upload_img" />
                      <label htmlFor="">Upload bill or invoice image</label>
                      <button type="button" className="img_btn">
                        <img src={upload_btn} alt="upload_btn" />
                        <span>Upload</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row border rounded-3 p-4 bg-white mt-2">
              <div className="row">
                <div>
                  <h5>Item</h5>
                </div>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="visiter_item_con">
                  <img src={item_img} alt="upload_img" />
                  <h5>Visiter has items? Add here</h5>
                  <button type="button" className="img_btn">
                    <img src={add_item} alt="upload_btn" />
                    <span>Add item</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vehicleadd;
